/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import styled from "styled-components";

export const CommentContainer = styled.div`
  margin: 1rem 0;
  padding: 10px;
`;
